import { SiteDeliveryType, SiteType } from 'data/__generated__';

export const SITE_TYPES_LABELS: { [key in SiteType]: string } = {
    [SiteType.BrokenProductsWarehouse]: 'Pertes Cassées',
    [SiteType.ExpiredProductsWarehouse]: 'Pertes Expirées',
    [SiteType.Microstore]: 'Microstore',
    [SiteType.Warehouse]: 'Entrepôt',
};

export const SITE_DELIVERY_TYPES_LABELS: { [key in SiteDeliveryType]: string } = {
    [SiteDeliveryType.MicrostoreDelivery]: 'Livraison bundles',
    [SiteDeliveryType.WarehouseDelivery]: 'Livraison par palette (entrepôt)',
    [SiteDeliveryType.PackageDelivery]: 'Livraison par DRY à la palette (bundles)',
    [SiteDeliveryType.RefrigeratedTruckDelivery]: 'Livraison par camion réfrigéré (frais)',
};
